<template>
  <div class="type_manage">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="所属区域" name="ten">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenAccountArea">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataAccountArea" size="medium" style="width: 100%">
          <el-table-column label='区域id'>
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label='区域名称'>
            <template slot-scope="scope">
              {{ scope.row.area_name }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditAccountArea(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--    页码-->
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionAccountArea.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionAccountArea.pageSize" :total="pageOptionAccountArea.total"
          @size-change="handleSizeChangeAccountArea" @current-change="handleCurrentChangeAccountArea">
        </el-pagination>
        <!--    添加-->
        <el-drawer title="添加" :visible.sync="AddDrawerAccountArea" :direction="direction" :before-close="handleClose"
          size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">所属区域名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入所属区域的名称" :size="inputSize" v-model="addDataAccountArea.area_name" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddAccountArea">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <!--    编辑-->
        <el-drawer title="编辑" :visible.sync="saveDrawerAccountArea" :direction="direction"
          :before-close="handleSaveDrawerClose" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">所属区域名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入所属区域的名称" :size="inputSize" v-model="saveDataAccountArea.area_name" clearable>
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div class="addCon">
            <el-button type="primary" size="mini" @click="handleSaveAccountArea">保存</el-button>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="公司规模" name="eleven">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenCompanyScale">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataCompanyScale" size="medium" style="width: 100%">
          <el-table-column label='规模id'>
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label='规模名称'>
            <template slot-scope="scope">
              {{ scope.row.scale_name }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditCompanyScale(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--    页码-->
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionCompanyScale.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionCompanyScale.pageSize" :total="pageOptionCompanyScale.total"
          @size-change="handleSizeChangeCompanyScale" @current-change="handleCurrentChangeCompanyScale">
        </el-pagination>
        <!--    添加-->
        <el-drawer title="添加" :visible.sync="AddDrawerCompanyScale" :direction="direction" :before-close="handleClose"
          size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">规模名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入规模名称" :size="inputSize" v-model="addDataCompanyScale.scale_name" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddCompanyScale">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <!--    编辑-->
        <el-drawer title="编辑" :visible.sync="saveDrawerCompanyScale" :direction="direction"
          :before-close="handleSaveDrawerClose" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">规模名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入规模名称" :size="inputSize" v-model="saveDataCompanyScale.scale_name" clearable>
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div class="addCon">
            <el-button type="primary" size="mini" @click="handleSaveCompanyScale">保存</el-button>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="核定税种" name="twelve">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenTaxCategory">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataTaxCategory" size="medium" style="width: 100%">
          <el-table-column label='税种id'>
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label='税种名称'>
            <template slot-scope="scope">
              {{ scope.row.tax_name }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditTaxCategory(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--    页码-->
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionTaxCategory.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionTaxCategory.pageSize" :total="pageOptionTaxCategory.total"
          @size-change="handleSizeChangeTaxCategory" @current-change="handleCurrentChangeTaxCategory">
        </el-pagination>
        <!--    添加-->
        <el-drawer title="添加" :visible.sync="AddDrawerTaxCategory" :direction="direction" :before-close="handleClose"
          size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">税种名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入税种名称" :size="inputSize" v-model="addDataTaxCategory.tax_name" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddTaxCategroy">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <!--    编辑-->
        <el-drawer title="编辑" :visible.sync="saveDrawerTaxCategory" :direction="direction"
          :before-close="handleSaveDrawerClose" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">税种名称</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入税种名称" :size="inputSize" v-model="saveDataTaxCategory.tax_name" clearable>
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div class="addCon">
            <el-button type="primary" size="mini" @click="handleSaveTaxCategory">保存</el-button>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="商机内容" name="thirteen">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenBussinessContent">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataBussinessContent" size="medium" style="width: 100%">
          <el-table-column label='商机id'>
            <template slot-scope="scope">
              {{ scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column label='商机内容'>
            <template slot-scope="scope">
              {{ scope.row.bussin_name }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditBussinessContent(scope.$index, scope.row)">
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--    页码-->
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionBussinessContent.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionBussinessContent.pageSize" :total="pageOptionBussinessContent.total"
          @size-change="handleSizeChangeBussinessContent" @current-change="handleCurrentChangeBussinessContent">
        </el-pagination>
        <!--    添加-->
        <el-drawer title="添加" :visible.sync="AddDrawerBussinessContent" :direction="direction"
          :before-close="handleClose" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">商机内容</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入商机内容" :size="inputSize" v-model="addDataBussinessContent.bussin_name"
                  clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddBussinessContent">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <!--    编辑-->
        <el-drawer title="编辑" :visible.sync="saveDrawerBussinessContent" :direction="direction"
          :before-close="handleSaveDrawerClose" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">商机内容</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入商机内容" :size="inputSize" v-model="saveDataBussinessContent.bussin_name"
                  clearable>
                </el-input>
              </el-col>
            </el-row>
          </div>
          <div class="addCon">
            <el-button type="primary" size="mini" @click="handleSaveBussinessContent">保存</el-button>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="所属税务局" name="fourteen">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenTaxBureau">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataTaxBureau" size="medium" style="width: 100%">
          <el-table-column label='税局名称' width="200">
            <template slot-scope="scope">
              {{ scope.row.tax_name }}
            </template>
          </el-table-column>
          <el-table-column label='专管员名称'>
            <template slot-scope="scope">
              <span v-if="scope.row.son.length">
                <span v-for="(item, index) in scope.row.son" :key="index">{{ item.tax_name + (item.phone ? ('-' +
                    item.phone) : '')
                }}<span v-if="index + 1 !== scope.row.son.length">，</span></span>
              </span>
              <span v-else style="opacity: 0.6;">暂无</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditTaxBureau(scope.$index, scope.row)">编辑</el-button>
              <el-popconfirm @onConfirm="handleDeleteTaxStaff(scope.row.id, 0)" confirmButtonText='确定'
                cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="删除当前税局名称，将会删除当前税局下的所有专管员，确认删除吗？">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionTaxBureau.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionTaxBureau.pageSize" :total="pageOptionTaxBureau.total"
          @size-change="handleSizeChangeTaxBureau" @current-change="handleCurrentChangeTaxBureau">
        </el-pagination>
        <el-drawer title="添加税局或专管员" :visible.sync="addTaxBureauDrawer" direction="rtl"
          :before-close="handleCloseTaxBureau" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">税务局名称</el-col>
              <el-col :span="10">
                <el-select :filterable="true" v-model="addDataTaxBureau.pid" placeholder="请选择税务局" size="mini" clearable>
                  <el-option v-for="(item, index) in pids" :key="index" :label="item.tax_name" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">{{ addDataTaxBureau.pid === 0 ? '税局名称' : '专管员名称' }}</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入专管员名称" size="mini" v-model="addDataTaxBureau.tax_name" clearable>
                </el-input>
              </el-col>
            </el-row>
            <el-row v-if="addDataTaxBureau.pid > 0">
              <el-col :span="6" class="m-label">专管员电话</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入专管员名称" size="mini" v-model="addDataTaxBureau.phone" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddTaxBureau">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <el-drawer title="编辑税局或专管员" :visible.sync="saveTaxBureauDrawer" direction="rtl"
          :before-close="handleCloseTaxBureau" size="40%">
          <div class="m-tabs-content">
            <el-card class="box-card" style="margin-bottom: .2rem;">
              <el-divider content-position="left">税务局</el-divider>
              <el-row>
                <el-col :span="14">
                  <el-input v-model="saveDataTaxBureau.tax_name" size="mini" clearable></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-button type="primary" size="mini" @click="handleSaveTaxBureau(saveDataTaxBureau)">保存</el-button>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card" v-if="saveDataTaxBureau.son.length">
              <el-divider content-position="left">税局专管员</el-divider>
              <div v-for="(item, index) in saveDataTaxBureau.son" :key="index" class="text item">
                <el-card style="margin-bottom: .2rem;">
                  <el-row>
                    <el-col :span="24" class="m-label">
                      <el-col :span="5" :offset="1" style="line-height: 28px;">专管员名称</el-col>
                      <el-col :span="12">
                        <el-input v-model="item.tax_name" size="mini" clearable></el-input>
                      </el-col>
                    </el-col>
                    <el-col :span="24" class="m-label">
                      <el-col :span="5" :offset="1" style="line-height: 28px;">专管员电话</el-col>
                      <el-col :span="12">
                        <el-input v-model="item.phone" size="mini" clearable></el-input>
                      </el-col>
                    </el-col>
                    <el-col :span="24" class="m-label">
                      <el-col :span="2" :offset="18">
                        <el-button type="primary" size="mini" @click="handleSaveTaxBureau(item)">保存</el-button>
                      </el-col>
                      <el-col :span="2" :offset="1">
                        <el-popconfirm title="确定删除当前专管员吗？" @onConfirm="handleDeleteTaxStaff(item.id, item.pid)">
                          <el-button slot="reference" type="warning" size="mini">删除</el-button>
                        </el-popconfirm>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-card>
              </div>
            </el-card>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="所属市场局" name="fifteen">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenMarketBureau">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="pageDataMarketBureau" size="medium" style="width: 100%">
          <el-table-column label='市场局名称' width="200">
            <template slot-scope="scope">
              {{ scope.row.market_name }}
            </template>
          </el-table-column>
          <el-table-column label='专管员名称'>
            <template slot-scope="scope">
              <span v-if="scope.row.son.length">
                <span v-for="(item, index) in scope.row.son" :key="index">{{ item.market_name + (item.phone ? ('-' +
                    item.phone) : '')
                }}<span v-if="index + 1 !== scope.row.son.length">，</span></span>
              </span>
              <span v-else style="opacity: 0.6;">暂无</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditMarketBureau(scope.$index, scope.row)">编辑</el-button>
              <el-popconfirm @onConfirm="handleDeleteMarketStaff(scope.row.id, 0)" confirmButtonText='确定'
                cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="删除当前市场局名称，将会删除当前市场局下的所有专管员，确认删除吗？">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionMarketBureau.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionMarketBureau.pageSize" :total="pageOptionMarketBureau.total"
          @size-change="handleSizeChangeMarketBureau" @current-change="handleCurrentChangeMarketBureau">
        </el-pagination>
        <el-drawer title="添加市场局或专管员" :visible.sync="addMarketBureauDrawer" direction="rtl"
          :before-close="handleCloseMarketBureau" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">税务局名称</el-col>
              <el-col :span="10">
                <el-select :filterable="true" v-model="addDataMarketBureau.pid" placeholder="请选择税务局" size="mini"
                  clearable>
                  <el-option v-for="(item, index) in marketpids" :key="index" :label="item.market_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6" class="m-label">{{ addDataMarketBureau.pid === 0 ? '市场局名称' : '专管员名称' }}</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入专管员名称" size="mini" v-model="addDataMarketBureau.market_name" clearable>
                </el-input>
              </el-col>
            </el-row>
            <el-row v-if="addDataMarketBureau.pid > 0">
              <el-col :span="6" class="m-label">专管员电话</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入专管员名称" size="mini" v-model="addDataMarketBureau.phone" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddMarketBureau">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <el-drawer title="编辑市场局或专管员" :visible.sync="saveMarketBureauDrawer" direction="rtl"
          :before-close="handleCloseMarketBureau" size="40%">
          <div class="m-tabs-content">
            <el-card class="box-card" style="margin-bottom: .2rem;">
              <el-divider content-position="left">税务局</el-divider>
              <el-row>
                <el-col :span="14">
                  <el-input v-model="saveDataMarketBureau.market_name" size="mini" clearable></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-button type="primary" size="mini" @click="handleSaveMarketBureau(saveDataMarketBureau)">保存
                  </el-button>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card" v-if="saveDataMarketBureau.son.length">
              <el-divider content-position="left">市场局专管员</el-divider>
              <div v-for="(item, index) in saveDataMarketBureau.son" :key="index" class="text item">
                <el-card style="margin-bottom: .2rem;">
                  <el-row>
                    <el-col :span="24" class="m-label">
                      <el-col :span="5" :offset="1" style="line-height: 28px;">专管员名称</el-col>
                      <el-col :span="12">
                        <el-input v-model="item.market_name" size="mini" clearable></el-input>
                      </el-col>
                    </el-col>
                    <el-col :span="24" class="m-label">
                      <el-col :span="5" :offset="1" style="line-height: 28px;">专管员电话</el-col>
                      <el-col :span="12">
                        <el-input v-model="item.phone" size="mini" clearable></el-input>
                      </el-col>
                    </el-col>
                    <el-col :span="24" class="m-label">
                      <el-col :span="2" :offset="18">
                        <el-button type="primary" size="mini" @click="handleSaveMarketBureau(item)">保存</el-button>
                      </el-col>
                      <el-col :span="2" :offset="1">
                        <el-popconfirm title="确定删除当前专管员吗？" @onConfirm="handleDeleteMarketStaff(item.id, item.pid)">
                          <el-button slot="reference" type="warning" size="mini">删除</el-button>
                        </el-popconfirm>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-card>
              </div>
            </el-card>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="投诉原因" name="complaint">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOpenComplaint">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="complaints" size="medium" style="width: 100%">
          <el-table-column label='id' prop="id"></el-table-column>
          <el-table-column label='原因' prop="reason"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditComplaint(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false" :current-page="pageOptionComplaint.currentPage" :page-sizes="[10, 20]"
          :page-size="pageOptionComplaint.pageSize" :total="pageOptionComplaint.total"
          @size-change="handleSizeChangeComplaint" @current-change="handleCurrentChangeComplaint">
        </el-pagination>
        <el-drawer title="添加投诉原因" :visible.sync="addComplaintDrawer" direction="rtl"
          :before-close="handleCloseAddComplaint" size="40%">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="6" class="m-label">投诉原因</el-col>
              <el-col :span="10">
                <el-input placeholder="请输入投诉原因" size="mini" v-model="addDataComplaint.reason" clearable>
                </el-input>
              </el-col>
            </el-row>
            <div class="addCon">
              <el-button type="primary" size="mini" @click="handleAddComplaint">添加</el-button>
            </div>
          </div>
        </el-drawer>
        <el-drawer title="编辑投诉原因" :visible.sync="upComplaintDrawer" direction="rtl"
          :before-close="handleCloseUpComplaint" size="40%">
          <div class="m-tabs-content">
            <el-card class="box-card" style="margin-bottom: .2rem;">
              <el-divider content-position="left">投诉原因</el-divider>
              <el-row>
                <el-col :span="14">
                  <el-input v-model="upDataComplaint.reason" size="mini" clearable></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-button type="primary" size="mini" @click="handleSaveComplaint">保存</el-button>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-drawer>
      </el-tab-pane>
      <el-tab-pane label="订单平台来源" name="orderFrom">
        <el-row style="text-align: right;margin-bottom: .4rem">
          <el-col :span="24">
            <el-button type="primary" size="mini" @click="handleAddOrderFromOpen">添加</el-button>
          </el-col>
        </el-row>
        <el-table :data="fromDatas" size="medium" style="width: 100%">
          <el-table-column label='id' prop="id"></el-table-column>
          <el-table-column label='订单来源' prop="name"></el-table-column>
          <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEditOrderFrom(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="tr mt-10"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="false"
          :current-page="pageOptionOrderFrom.currentPage"
          :page-sizes="[10, 20]"
          :page-size="pageOptionOrderFrom.pageSize"
          :total="pageOptionOrderFrom.total"
          @size-change="handleSizeChangeOrderFrom"
          @current-change="handleCurrentChangeOrderFrom">
        </el-pagination>
        <el-drawer
          title="添加投诉原因"
          :visible.sync="addComplaintDrawer"
          direction="rtl"
          :before-close="handleCloseAddComplaint"
          size="40%">
            <div class="m-tabs-content">
              <el-row>
                <el-col :span="6"  class="m-label">投诉原因</el-col>
                <el-col :span="10">
                  <el-input
                    placeholder="请输入投诉原因"
                    size="mini"
                    v-model="addDataComplaint.reason"
                    clearable>
                  </el-input>
                </el-col>
              </el-row>
              <div class="addCon">
                <el-button type="primary" size="mini" @click="handleAddComplaint">添加</el-button>
              </div>
            </div>
          </el-drawer>
          <el-drawer
          title="添加订单平台来源"
          :visible.sync="addOrderFromDrawer"
          direction="rtl"
          :before-close="handleCloseAddOrderFrom"
          size="40%">
            <div class="m-tabs-content">
              <el-row>
                <el-col :span="6"  class="m-label">订单平台来源</el-col>
                <el-col :span="10">
                  <el-input
                    placeholder="请输入订单平台来源"
                    size="mini"
                    v-model="addOrderFrom.from"
                    clearable>
                  </el-input>
                </el-col>
              </el-row>
              <div class="addCon">
                <el-button type="primary" size="mini" @click="handleAddOrderFrom">添加</el-button>
              </div>
            </div>
          </el-drawer>
          <el-drawer
            title="编辑投诉原因"
            :visible.sync="upComplaintDrawer"
            direction="rtl"
            :before-close="handleCloseUpComplaint"
            size="40%">
              <div class="m-tabs-content">
                <el-card class="box-card" style="margin-bottom: .2rem;">
                  <el-divider content-position="left">投诉原因</el-divider>
                  <el-row>
                    <el-col :span="14"><el-input v-model="upDataComplaint.reason" size="mini" clearable></el-input></el-col>
                    <el-col :span="4" :offset="1"><el-button type="primary" size="mini" @click="handleSaveComplaint">保存</el-button></el-col>
                  </el-row>
                </el-card>
              </div>
            </el-drawer>
            <el-drawer
            title="编辑订单平台来源"
            :visible.sync="editOrderFromDrawer"
            direction="rtl"
            :before-close="handleCloseEditOrderFrom"
            size="40%">
              <div class="m-tabs-content">
                <el-card class="box-card" style="margin-bottom: .2rem;">
                  <el-divider content-position="left">订单平台来源</el-divider>
                  <el-row>
                    <el-col :span="14"><el-input v-model="upDataOrderFrom.from" size="mini" clearable></el-input></el-col>
                    <el-col :span="4" :offset="1"><el-button type="primary" size="mini" @click="handleSaveOrderFrom">保存</el-button></el-col>
                  </el-row>
                </el-card>
              </div>
            </el-drawer>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'type_manage',
  data () {
    return {
      listSort: [],
      fromDatas: [],
      addOrderFromDrawer: false,
      inputSize: 'small',
      activeName: 'ten',
      optionAccountArea: [],
      optionCompanyScale: [],
      optionTaxCategory: [],
      optionBussinessContent: [],
      pageOptionAccountArea: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionCompanyScale: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionTaxCategory: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionBussinessContent: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      AddDrawerAccountArea: false,
      saveDrawerAccountArea: false,
      AddDrawerCompanyScale: false,
      saveDrawerCompanyScale: false,
      AddDrawerTaxCategory: false,
      saveDrawerTaxCategory: false,
      AddDrawerBussinessContent: false,
      saveDrawerBussinessContent: false,
      direction: 'rtl',
      addDataAccountArea: {
        id: '',
        area_name: ''
      },
      saveDataAccountArea: {
        id: '',
        area_name: '',
        index: null
      },
      addDataCompanyScale: {
        id: '',
        scale_name: ''
      },
      saveDataCompanyScale: {
        id: '',
        scale_name: '',
        index: null
      },
      addDataTaxCategory: {
        id: '',
        tax_name: ''
      },
      saveDataTaxCategory: {
        id: '',
        tax_name: '',
        index: null
      },
      addDataBussinessContent: {
        id: '',
        bussin_name: ''
      },
      saveDataBussinessContent: {
        id: '',
        bussin_name: '',
        index: null
      },
      addTaxBureauDrawer: false,
      saveTaxBureauDrawer: false,
      pids: [],
      taxBureau: [],
      addDataTaxBureau: {
        pid: null,
        tax_name: '',
        phone: ''
      },
      saveDataTaxBureau: {
        index: null,
        id: null,
        pid: null,
        tax_name: '',
        phone: '',
        son: []
      },
      pageOptionTaxBureau: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      addMarketBureauDrawer: false,
      saveMarketBureauDrawer: false,
      marketpids: [],
      MarketBureau: [],
      addDataMarketBureau: {
        pid: null,
        market_name: '',
        phone: ''
      },
      saveDataMarketBureau: {
        index: null,
        id: null,
        pid: null,
        market_name: '',
        phone: '',
        son: []
      },
      pageOptionMarketBureau: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      complaints: [],
      addComplaintDrawer: false,
      pageOptionComplaint: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      pageOptionOrderFrom: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      addDataComplaint: {
        reason: ''
      },
      addOrderFrom: {
        from: ''
      },
      upDataComplaint: {
        index: null,
        id: null,
        reason: ''
      },
      upDataOrderFrom: {
        index: null,
        id: null,
        from: ''
      },
      upComplaintDrawer: false,
      editOrderFromDrawer: false
    }
  },
  computed: {
    pageDataAccountArea: {
      get: function () {
        return this.optionAccountArea.slice(this.pageOptionAccountArea.pageSize * (this.pageOptionAccountArea.currentPage - 1), this.pageOptionAccountArea.pageSize * this.pageOptionAccountArea.currentPage)
      }
    },
    pageDataCompanyScale: {
      get: function () {
        return this.optionCompanyScale.slice(this.pageOptionCompanyScale.pageSize * (this.pageOptionCompanyScale.currentPage - 1), this.pageOptionCompanyScale.pageSize * this.pageOptionCompanyScale.currentPage)
      }
    },
    pageDataTaxCategory: {
      get: function () {
        return this.optionTaxCategory.slice(this.pageOptionTaxCategory.pageSize * (this.pageOptionTaxCategory.currentPage - 1), this.pageOptionTaxCategory.pageSize * this.pageOptionTaxCategory.currentPage)
      }
    },
    pageDataBussinessContent: {
      get: function () {
        return this.optionBussinessContent.slice(this.pageOptionBussinessContent.pageSize * (this.pageOptionBussinessContent.currentPage - 1), this.pageOptionBussinessContent.pageSize * this.pageOptionBussinessContent.currentPage)
      }
    },
    pageDataTaxBureau: {
      get: function () {
        return this.taxBureau.slice(this.pageOptionTaxBureau.pageSize * (this.pageOptionTaxBureau.currentPage - 1), this.pageOptionTaxBureau.pageSize * this.pageOptionTaxBureau.currentPage)
      }
    },
    pageDataMarketBureau: {
      get: function () {
        return this.MarketBureau.slice(this.pageOptionMarketBureau.pageSize * (this.pageOptionMarketBureau.currentPage - 1), this.pageOptionMarketBureau.pageSize * this.pageOptionMarketBureau.currentPage)
      }
    }
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 所属区域
    getDataAccountArea () {
      this.$axios.get('/api/account_area')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionAccountArea = data.data
            this.pageOptionAccountArea.total = this.optionAccountArea.length
          }
        })
    },
    handleAddOpenAccountArea () {
      this.AddDrawerAccountArea = true
    },
    handleAddAccountArea () {
      if (!this.addDataAccountArea.area_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/account_area', { area_name: this.addDataAccountArea.area_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionAccountArea.unshift(data.data)
            this.pageOptionAccountArea.total = this.optionAccountArea.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerAccountArea = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditAccountArea (index, row) {
      this.saveDataAccountArea.area_name = row.area_name
      this.saveDataAccountArea.id = row.id
      this.saveDataAccountArea.index = index
      this.saveDrawerAccountArea = true
    },
    handleSaveAccountArea () {
      if (!this.saveDataAccountArea.area_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.patch('/api/account_area/' + this.saveDataAccountArea.id, { area_name: this.saveDataAccountArea.area_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionAccountArea.pageSize * (this.pageOptionAccountArea.currentPage - 1) + this.saveDataAccountArea.index
          this.optionAccountArea[index].area_name = this.saveDataAccountArea.area_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerAccountArea = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeAccountArea (val) {
      this.pageOptionAccountArea.pageSize = val
    },
    handleCurrentChangeAccountArea (val) {
      this.pageOptionAccountArea.currentPage = val
    },
    // 公司规模
    getDataCompanyScale () {
      this.$axios.get('/api/company_scale')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionCompanyScale = data.data
            this.pageOptionCompanyScale.total = this.optionCompanyScale.length
          }
        })
    },
    handleAddOpenCompanyScale () {
      this.AddDrawerCompanyScale = true
    },
    handleAddCompanyScale () {
      if (!this.addDataCompanyScale.scale_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/company_scale', { scale_name: this.addDataCompanyScale.scale_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionCompanyScale.unshift(data.data)
            this.pageOptionCompanyScale.total = this.optionCompanyScale.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerCompanyScale = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditCompanyScale (index, row) {
      this.saveDataCompanyScale.scale_name = row.scale_name
      this.saveDataCompanyScale.id = row.id
      this.saveDataCompanyScale.index = index
      this.saveDrawerCompanyScale = true
    },
    handleSaveCompanyScale () {
      if (!this.saveDataCompanyScale.scale_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.patch('/api/company_scale/' + this.saveDataCompanyScale.id, { scale_name: this.saveDataCompanyScale.scale_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionCompanyScale.pageSize * (this.pageOptionCompanyScale.currentPage - 1) + this.saveDataCompanyScale.index
          this.optionCompanyScale[index].scale_name = this.saveDataCompanyScale.scale_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerCompanyScale = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeCompanyScale (val) {
      this.pageOptionCompanyScale.pageSize = val
    },
    handleCurrentChangeCompanyScale (val) {
      this.pageOptionCompanyScale.currentPage = val
    },
    // 核定税种
    getDataTaxCategory () {
      this.$axios.get('/api/tax_category')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionTaxCategory = data.data
            this.pageOptionTaxCategory.total = this.optionTaxCategory.length
          }
        })
    },
    handleAddOpenTaxCategory () {
      this.AddDrawerTaxCategory = true
    },
    handleAddTaxCategroy () {
      if (!this.addDataTaxCategory.tax_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/tax_category', { tax_name: this.addDataTaxCategory.tax_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionTaxCategory.unshift(data.data)
            this.pageOptionTaxCategory.total = this.optionTaxCategory.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerTaxCategory = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditTaxCategory (index, row) {
      this.saveDataTaxCategory.tax_name = row.tax_name
      this.saveDataTaxCategory.id = row.id
      this.saveDataTaxCategory.index = index
      this.saveDrawerTaxCategory = true
    },
    handleSaveTaxCategory () {
      if (!this.saveDataTaxCategory.tax_name) {
        this.$message.error('税种名称不能为空')
        return
      }
      this.$axios.patch('/api/tax_category/' + this.saveDataTaxCategory.id, { tax_name: this.saveDataTaxCategory.tax_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionTaxCategory.pageSize * (this.pageOptionTaxCategory.currentPage - 1) + this.saveDataTaxCategory.index
          this.optionTaxCategory[index].tax_name = this.saveDataTaxCategory.tax_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerTaxCategory = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeTaxCategory (val) {
      this.pageOptionTaxCategory.pageSize = val
    },
    handleCurrentChangeTaxCategory (val) {
      this.pageOptionTaxCategory.currentPage = val
    },
    // 商机内容
    getDataBussinessContent () {
      this.$axios.get('/api/bussin_content')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionBussinessContent = data.data
            this.pageOptionBussinessContent.total = this.optionBussinessContent.length
          }
        })
    },
    handleAddBussinessContent () {
      if (!this.addDataBussinessContent.bussin_name) {
        this.$message.error('区域名称不能为空')
        return
      }
      this.$axios.post('/api/bussin_content', { bussin_name: this.addDataBussinessContent.bussin_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionBussinessContent.unshift(data.data)
            this.pageOptionBussinessContent.total = this.optionBussinessContent.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerBussinessContent = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditBussinessContent (index, row) {
      this.saveDataBussinessContent.bussin_name = row.bussin_name
      this.saveDataBussinessContent.id = row.id
      this.saveDataBussinessContent.index = index
      this.saveDrawerBussinessContent = true
    },
    handleAddOpenBussinessContent () {
      this.AddDrawerBussinessContent = true
    },
    handleSaveBussinessContent () {
      if (!this.saveDataBussinessContent.bussin_name) {
        this.$message.error('商机内容不能为空')
        return
      }
      this.$axios.patch('/api/bussin_content/' + this.saveDataBussinessContent.id, { bussin_name: this.saveDataBussinessContent.bussin_name }
      ).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionBussinessContent.pageSize * (this.pageOptionBussinessContent.currentPage - 1) + this.saveDataBussinessContent.index
          this.optionBussinessContent[index].bussin_name = this.saveDataBussinessContent.bussin_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerBussinessContent = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleSizeChangeBussinessContent (val) {
      this.pageOptionBussinessContent.pageSize = val
    },
    handleCurrentChangeBussinessContent (val) {
      this.pageOptionBussinessContent.currentPage = val
    },
    handleSaveDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    clearAddData () {
      this.addDataAccountArea.area_name = ''
      this.addDataCompanyScale.scale_name = ''
      this.addDataTaxCategory.tax_name = ''
      this.addDataBussinessContent.bussin_name = ''
    },
    clearSaveData () {
      this.saveDataAccountArea.area_name = ''
      this.saveDataCompanyScale.scale_name = ''
      this.saveDataTaxCategory.tax_name = ''
      this.saveDataBussinessContent.bussin_name = ''
    },
    // 所属税务局
    getDataTaxBureau () {
      this.$axios.get('/api/tax_bureau')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.taxBureau = data.data.list
            this.pids = data.data.pids
            this.pids.unshift({ id: 0, tax_name: '添加税务局' })
            this.pageOptionTaxBureau.total = data.data.list.length
          }
        })
    },
    handleSizeChangeTaxBureau (val) {
      this.pageOptionTaxBureau.pageSize = val
    },
    handleCurrentChangeTaxBureau (val) {
      this.pageOptionTaxBureau.currentPage = val
    },
    handleAddOpenTaxBureau () {
      this.addTaxBureauDrawer = true
    },
    handleAddTaxBureau () {
      if (this.addDataTaxBureau.pid === null) {
        this.$message.error('请选择税务局')
        return false
      }
      if (!this.addDataTaxBureau.tax_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (this.addDataTaxBureau.pid > 0 && !this.addDataTaxBureau.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/tax_bureau', this.addDataTaxBureau)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditTaxBureau (index, row) {
      this.saveDataTaxBureau.index = index
      this.saveDataTaxBureau.id = row.id
      this.saveDataTaxBureau.pid = row.pid
      this.saveDataTaxBureau.tax_name = row.tax_name
      this.saveDataTaxBureau.phone = row.phone
      this.saveDataTaxBureau.son = row.son
      this.saveTaxBureauDrawer = true
    },
    handleSaveTaxBureau (item) {
      if (item.pid === null) {
        this.$message.error('请选择税务局')
        return false
      }
      if (!item.tax_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (item.pid > 0 && !item.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/tax_bureau/' + item.id, item)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteTaxStaff (id, pid) {
      this.$axios.post('/api/tax_bureau/' + id + '/' + pid)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseTaxBureau()
            this.getDataTaxBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCloseTaxBureau () {
      this.addTaxBureauDrawer = false
      this.saveTaxBureauDrawer = false
      this.addDataTaxBureau.pid = null
      this.addDataTaxBureau.tax_name = ''
      this.addDataTaxBureau.phone = ''
      this.saveDataTaxBureau.pid = null
      this.saveDataTaxBureau.tax_name = ''
      this.saveDataTaxBureau.phone = ''
      this.saveDataTaxBureau.index = null
      this.saveDataTaxBureau.son = []
    },
    // 所属市场局
    getDataMarketBureau () {
      this.$axios.get('/api/market_bureau')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.MarketBureau = data.data.list
            this.marketpids = data.data.pids
            this.marketpids.unshift({ id: 0, market_name: '添加市场局' })
            this.pageOptionMarketBureau.total = data.data.list.length
          }
        })
    },
    handleSizeChangeMarketBureau (val) {
      this.pageOptionMarketBureau.pageSize = val
    },
    handleCurrentChangeMarketBureau (val) {
      this.pageOptionMarketBureau.currentPage = val
    },
    handleAddOpenMarketBureau () {
      this.addMarketBureauDrawer = true
    },
    handleAddMarketBureau () {
      if (this.addDataMarketBureau.pid === null) {
        this.$message.error('请选择市场局')
        return false
      }
      if (!this.addDataMarketBureau.market_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (this.addDataMarketBureau.pid > 0 && !this.addDataMarketBureau.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/market_bureau', this.addDataMarketBureau)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditMarketBureau (index, row) {
      this.saveDataMarketBureau.index = index
      this.saveDataMarketBureau.id = row.id
      this.saveDataMarketBureau.pid = row.pid
      this.saveDataMarketBureau.market_name = row.market_name
      this.saveDataMarketBureau.phone = row.phone
      this.saveDataMarketBureau.son = row.son
      this.saveMarketBureauDrawer = true
    },
    handleSaveMarketBureau (item) {
      if (item.pid === null) {
        this.$message.error('请选择市场局')
        return false
      }
      if (!item.market_name) {
        this.$message.error('请填写名称')
        return false
      }
      if (item.pid > 0 && !item.phone) {
        this.$message.error('请填写专管员电话')
        return false
      }
      this.$axios.post('/api/market_bureau/' + item.id, item)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteMarketStaff (id, pid) {
      this.$axios.post('/api/market_bureau/' + id + '/' + pid)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.handleCloseMarketBureau()
            this.getDataMarketBureau()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCloseMarketBureau () {
      this.addMarketBureauDrawer = false
      this.saveMarketBureauDrawer = false
      this.addDataMarketBureau.pid = null
      this.addDataMarketBureau.market_name = ''
      this.addDataMarketBureau.phone = ''
      this.saveDataMarketBureau.pid = null
      this.saveDataMarketBureau.market_name = ''
      this.saveDataMarketBureau.phone = ''
      this.saveDataMarketBureau.index = null
      this.saveDataMarketBureau.son = []
    },
    // 投诉原因
    getComplaints () {
      this.$axios.get('/api/admin/complaints')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.complaints = data.data.data
            this.pageOptionComplaint.total = data.data.total
          }
        })
    },
    getFroms () {
      this.$axios.get('api/get_order_from?page=' + this.pageOptionOrderFrom.currentPage)
        .then((res) => {
          let { data } = res
          if (data.code === 1) {
            this.fromDatas = data.data.data
            this.pageOptionOrderFrom.total = data.data.total
            this.loadSort()
          }
        })
    },
    handleSizeChangeComplaint (val) {
      this.pageOptionComplaint.pageSize = val
    },
    handleSizeChangeOrderFrom (val) {
      this.pageOptionOrderFrom.pageSize = val
    },
    handleCurrentChangeComplaint (val) {
      this.pageOptionComplaint.currentPage = val
    },
    handleCurrentChangeOrderFrom (val) {
      this.pageOptionOrderFrom.currentPage = val
      setTimeout(() => {
        this.getFroms()
      })
    },
    handleAddOpenComplaint () {
      this.addComplaintDrawer = true
    },
    handleCloseAddComplaint (done) {
      this.addDataComplaint.reason = ''
      done()
    },
    handleCloseAddOrderFrom (done) {
      // this.addDataComplaint.reason = ''
      done()
    },
    handleAddComplaint () {
      console.log(this.addDataComplaint)
      if (!this.addDataComplaint.reason) {
        this.$message.error('请输入投诉原因')
        return
      }

      this.$axios.post('/api/admin/complaints', this.addDataComplaint)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.addDataComplaint.reason = ''
            this.addComplaintDrawer = false
            this.pageOptionComplaint.currentPage = 1
            this.getComplaints()
            this.$message.success(data.msg)
          }
        })
    },
    handleAddOrderFrom () {
      if (!this.addOrderFrom.from) {
        this.$message.error('请输入订单平台来源')
        return
      }
      this.$axios.post('api/add_order_from', this.addOrderFrom)
        .then((res) => {
          let { data } = res
          if (data.code === 1) {
            this.addOrderFrom.from = ''
            this.addOrderFromDrawer = false
            this.pageOptionComplaint.currentPage = 1
            this.getFroms()
            this.$message.success(data.msg)
          }
        })
    },
    handleEditComplaint (index, row) {
      this.upDataComplaint.index = index
      this.upDataComplaint.id = row.id
      this.upDataComplaint.reason = row.reason
      this.upComplaintDrawer = true
    },
    handleEditOrderFrom (index, row) {
      this.upDataOrderFrom.index = index
      this.upDataOrderFrom.id = row.id
      this.upDataOrderFrom.from = row.name
      this.editOrderFromDrawer = true
    },
    handleSaveComplaint () {
      if (!this.upDataComplaint.reason) {
        this.$message.error('投诉原因不能为空')
        return
      }

      this.$axios.post('/api/admin/complaints/' + this.upDataComplaint.id, this.upDataComplaint)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.complaints[this.upDataComplaint.index].reason = this.upDataComplaint.reason
            this.clearUpDataComplaint()
            this.upComplaintDrawer = false
            this.$message.success(data.msg)
          }
        })
    },
    handleSaveOrderFrom () {
      if (!this.upDataOrderFrom.from) {
        this.$message.error('订单平台来源不能为空！')
        return
      }

      this.$axios.put('api/edit_order_from/' + this.upDataOrderFrom.id, this.upDataOrderFrom)
        .then((res) => {
          let { data } = res
          if (data.code === 1) {
            this.fromDatas[this.upDataOrderFrom.index].name = this.upDataOrderFrom.from
            this.clearUpDataOrderFrom()
            this.editOrderFromDrawer = false
            this.$message.success(data.msg)
          }
        })
    },
    clearUpDataComplaint () {
      this.upDataComplaint.index = null
      this.upDataComplaint.id = null
      this.upDataComplaint.reason = ''
    },
    clearUpDataOrderFrom () {
      this.upDataOrderFrom.index = ''
      this.upDataOrderFrom.id = ''
      this.upDataOrderFrom.from = ''
    },
    handleCloseUpComplaint (done) {
      this.clearUpDataComplaint()
      done()
    },
    handleCloseEditOrderFrom (done) {
      this.clearUpDataOrderFrom()
      done()
    },
    handleAddOrderFromOpen () {
      this.addOrderFromDrawer = true
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/account/edit_sort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.getFroms()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadSort () {
      this.fromDatas.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    }
  },
  mounted () {
    this.getDataAccountArea()
    this.getDataCompanyScale()
    this.getDataTaxCategory()
    this.getDataBussinessContent()
    this.getDataTaxBureau()
    this.getDataMarketBureau()
    this.getComplaints()
    this.getFroms()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .type_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .type_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/type_manage/type_manage.vue